import { render, staticRenderFns } from "./Collect2.vue?vue&type=template&id=4cff5823&scoped=true"
import script from "./Collect2.vue?vue&type=script&lang=js"
export * from "./Collect2.vue?vue&type=script&lang=js"
import style0 from "./Collect2.vue?vue&type=style&index=0&id=4cff5823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cff5823",
  null
  
)

export default component.exports